import { PaddedContainer } from '@/atoms/PaddedContainer'
import { Durations } from '@/constants/durations'
import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { AccountLayout } from '@/layouts/AccountLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getGenericStaticPaths } from '@/utils/nextUtils/staticPages'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CollectiblesCheckoutView } from '@/views/CollectiblesCheckoutView'

interface CollectibleCheckoutProps {
  locale: string
}

export const CollectibleCheckout: NextPageWithLayout<CollectibleCheckoutProps> = ({ locale }) => {
  const { t } = useTranslate('collectibles-marketplace')

  const title = t('exclusiveSignedCollectibles', 'Exclusive Signed Collectibles')
  const description = t(
    'getYourExclusiveCollectibles',
    'Get your Exclusive Collectibles signed by one of your favorite Chosen cast members',
  )

  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          locale,
          path: paths.collectiblesMarketplace.index,
          title,
          description,
          cloudinaryImagePath: 'v1756153598/angel-studios/seo/angel-opengraph-5',
          cloudinaryTransformation: '',
        })}
        noindex
      />
      <div className="bg-white pt-20">
        <PaddedContainer>
          <CollectiblesCheckoutView />
        </PaddedContainer>
      </div>
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler<CollectibleCheckoutProps>(
  { filePath: 'pages/[locale]/collectibles/checkout/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'collectibles-marketplace', 'account'])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

CollectibleCheckout.getLayout = (page) => {
  return <AccountLayout isDarkMode={false}>{page}</AccountLayout>
}

export default CollectibleCheckout
